<template>
  <section
    id="home"
    class="hero-section"
  >
    <div class="hero-bg">
      <div class="splash-left" />
      <div class="splash-right" />
      <div class="splash-bottom" />
    </div>
    <div class="hero-content">
      <div class="hero-container">
        <div class="hero-grid">
          <!-- Left Content -->
          <div class="hero-text">
            <div class="hero-badge">
              <i class="fas fa-star" />
              <span>Northeastern College</span>
            </div>
            <h1 class="hero-title">
              <span class="title-small">Welcome to</span>
              Office of
              <span class="text-highlight">Student</span>
              <span class="text-box">Affairs</span>
              <span class="title-and">&amp;</span>
              <span class="text-highlight-yellow">Services</span>
            </h1>
            <p class="hero-description">
              Empowering students through comprehensive support services,
              holistic development programs, and dedicated guidance for
              academic and personal success.
            </p>
            <div class="hero-buttons">
              <router-link
                to="/home/book-appointment"
                class="btn-primary"
              >
                <span>Book Appointment</span>
                <i class="fas fa-arrow-right" />
              </router-link>
              <button
                class="btn-secondary"
                @click="$emit('scroll-to-section', 'contact')"
              >
                <i class="fas fa-phone-alt" />
                <span>Contact Us</span>
              </button>

            </div>
          </div>

          <!-- Floating Visual with Flipping Logos -->
          <div class="hero-visual">
            <div class="logo-flip-wrapper">
              <div class="logo-flipper">
                <div class="logo-front">
                  <img
                    src="@/assets/images/logo/nclogo.png"
                    alt="NC Logo"
                  >
                </div>
                <div class="logo-back">
                  <img
                    src="@/assets/images/logo/osaslogo.png"
                    alt="OSAS Logo"
                  >
                </div>
              </div>
            </div>
            <div class="stats-floating">
              <div class="stat-card stat-1">
                <div class="stat-icon green">
                  <i class="fas fa-user-graduate" />
                </div>
                <div class="stat-content">
                  <div>
                    5,000+
                  </div>
                  <div>
                    Students Served
                  </div>
                </div>
              </div>
              <div class="stat-card stat-2">
                <div class="stat-icon yellow">
                  <i class="fas fa-hands-helping" />
                </div>
                <div class="stat-content">
                  <div>
                    15+
                  </div>
                  <div>
                    Services Offered
                  </div>
                </div>
              </div>
              <div class="stat-card stat-3">
                <div class="stat-icon green">
                  <i class="fas fa-users" />
                </div>
                <div class="stat-content">
                  <div>
                    30+
                  </div>
                  <div>
                    Student Orgs
                  </div>
                </div>
              </div>
              <div class="stat-card stat-4">
                <div class="stat-icon yellow">
                  <i class="fas fa-calendar-check" />
                </div>
                <div class="stat-content">
                  <div>
                    100+
                  </div>
                  <div>
                    Events Yearly
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Scroll Indicator -->
    <div class="scroll-indicator">
      <div class="scroll-mouse">
        <div class="scroll-wheel" />
      </div>
      <span>Scroll to explore</span>
    </div>
  </section>
</template>

<script>
import '../../../assets/css/landing/hero-section.css'

export default {
  name: 'HeroSection'
}
</script>
